<label class="switch">
  <input type="checkbox" [(ngModel)]="value" />
  <span class="slider round"></span>
</label>
